import WordPressConnect from './wordpress.connect.vue'

function install (Vue, options = {}) {
  const property = options.property || '$wordpress'
  delete options.property
  const vuetify = options.vuetify
  delete options.vuetify
  const i18n = options.i18n
  delete options.i18n

  const WordPressConnectCtor = Vue.extend(Object.assign({ vuetify, i18n }, WordPressConnect))

  function connect () {
    const container = document.querySelector('[data-app=true]') || document.body

    return new Promise(resolve => {
      const cmp = new WordPressConnectCtor(Object.assign({}, {
        destroyed: () => {
          container.removeChild(cmp.$el)
          resolve(cmp.result)
        }
      }))
      container.appendChild(cmp.$mount().$el)
    })
  }

  Vue.prototype[property] = { connect }
  Vue.prototype[property].options = options || {}
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}

export default install
